import React, { useEffect, useState } from "react";
import useMonthlyPayslipStore from "../../../config/stores/administration/useMonthlyPayslipStore";
import { searchTable } from "../../../config/constants";
import TableTitle from "../../../components/common/TableTitle";
import AntdTable from "../../../components/common/AntdTable";
import TableButtonActions from "../../../components/common/TableButtonActions";
import RecordStatus from "../../../components/common/RecordStatus";
import moment from "moment";
import PayslipForm from "./PayslipForm";
import PayslipDetails from "./PayslipDetails";

const AllPayslips = () => {
  const [filterTable, setFilterTableNull] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const payslipStore = useMonthlyPayslipStore();
  const {
    payslips,
    getAllPayslips,
    gettingPayslips,
    setShowPayslipDetails,
    showPayslipDetails,
    payslipDetailsRecord,
    deletePayslip,
    setCreatingPayslip,
    showCreatePayslip,
  } = payslipStore;

  const search = (value) => {
    const filterTable = searchTable(payslips, value);
    setFilterTableNull(filterTable);
  };

  const confirmDelete = () => {
    deletePayslip(deleteId);
    setDeleteId(null);
  };

  const deleteRecord = (id) => setDeleteId(id);

  const viewDetails = (record) => {
    payslipStore.setShowPayslipDetails(true);
    payslipStore.getPayslipDetails(record.id);
  };

  const editPayslip = (record) => {
    setCreatingPayslip(true, false, record);
  };

  const createPayslip = () => {
    setCreatingPayslip(true, true, null);
  };

  const refreshTable = () => {
    getAllPayslips();
  };

  useEffect(() => {
    getAllPayslips();
  }, []);

  const columns = [
    {
      title: "Employee",
      dataIndex: ["user", "first_name"],
      key: "employee",
      render: (_, record) => `${record?.user?.first_name || ""} ${record?.user?.other_names || ""}`,
    },
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
      render: (month) => moment(month, "M").format("MMMM"),
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <RecordStatus status={status} />,
    },
    {
      title: "Net Salary",
      dataIndex: "net_salary",
      key: "net_salary",
      render: (netSalary) => `UGX ${netSalary?.toLocaleString()}`
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <TableButtonActions
          record={record}
          confirmDelete={confirmDelete}
          deleteLoading={payslipStore.deletingPayslip}
          viewDetails={() => viewDetails(record)}
          updateRecord={() => editPayslip(record)}
          deleteId={deleteId}
          deleteRecord={deleteRecord}
        />
      ),
    },
  ];


  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">MONTHLY PAYSLIPS</h5>
    
      {/* Payslip Details */}
      {payslipStore.showPayslipDetails ?  <PayslipDetails /> : <>
      
        <AntdTable
        loading={gettingPayslips}
        title={() => (
          <TableTitle
            setFilterTableNull={setFilterTableNull}
            refreshTable={refreshTable}
            search={search}
            exportRecords={null}
            openAddModal={createPayslip}
            addNewText="CREATE PAYSLIP"
          />
        )}
        pageSize={20}
        data={filterTable === null ? payslips || [] : filterTable}
        columns={columns}
      />
      {/* Payslip Form Modal */}
      <PayslipForm />
      </>}
    </div>
  );
};
 
export default AllPayslips; 